import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useQuery } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';

import { Pagination } from 'components';

import { ACCOMMODATIONS } from 'graphql/queries/accommodations';

import {
  Typography,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Button
} from '@material-ui/core';

import useStyles from './styles';

const headingsConfig = classes => {
  return [
    { label: 'Photo', align: 'left', cellClassName: classes.imgCell },
    {
      label: 'Accommodation',
      cellClassName: classes.nameCell,
      align: 'left'
    },
    {
      label: 'Product code',
      cellClassName: classes.productCodeCell,
      align: 'left'
    },
    {
      label: 'Location',
      cellClassName: classes.locationCell,
      align: 'left'
    },
    {
      label: 'Guests',
      cellClassName: classes.guestsCell,
      align: 'left'
    },
    { label: '', align: 'right' }
  ];
};

function AccommodationsList({ businessOwner }) {
  const classes = useStyles();
  const history = useHistory();
  const [t] = useTranslation();

  const [page, setPage] = React.useState(0);

  const { data, refetch } = useQuery(ACCOMMODATIONS, {
    variables: {
      page: page,
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    }
  });

  React.useEffect(() => {
    refetch();
  }, []);

  const onPageChangeHandler = (e, page) => {
    refetch({
      page: page - 1
    });
    setPage(page - 1);
  };

  return (
    <TableContainer component="div" classes={{ root: classes.container }}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead className={classes.tableHead}>
          <TableRow>
            {headingsConfig(classes).map(heading => (
              <TableCell
                key={heading.label}
                align={heading.align}
                className={classNames(
                  classes.tableCell,
                  classes.headTableCell,
                  heading.cellClassName
                )}
              >
                <Typography variant="h3" className={classes.heading}>
                  {t(heading.label)}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.accommodations &&
            data.accommodations.map(accommodation => (
              <TableRow
                key={accommodation.id}
                classes={{ root: classes.tableRow }}
                onClick={() =>
                  history.push(`/accommodations/${accommodation.id}/book`)
                }
              >
                <TableCell
                  className={classNames(classes.tableCell, classes.imgCell)}
                  component="th"
                  scope="row"
                >
                  <div className={classes.imageWrapper}>
                    {accommodation.photo && (
                      <img
                        src={accommodation.photo}
                        alt=""
                        className={classes.image}
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell
                  className={classNames(classes.tableCell, classes.nameCell)}
                  align="left"
                >
                  {accommodation.title}
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.productCodeCell
                  )}
                  align="left"
                >
                  {accommodation.productCode}
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.locationCell
                  )}
                  align="left"
                >
                  {accommodation.location}
                </TableCell>
                <TableCell
                  className={classNames(classes.tableCell, classes.guestsCell)}
                  align="left"
                >
                  {accommodation.guestsNumber}
                </TableCell>
                {/* <TableCell className={classes.tableCell} align="right">
                  <Button
                    onClick={e => {
                      e.stopPropagation();
                      history.push(
                        `/accommodations/${accommodation.id}/manual-book`
                      );
                    }}
                    variant="outlined"
                    color="primary"
                    classes={{ root: classes.buttonRoot }}
                  >
                    {t('Manual book')}
                  </Button>
                </TableCell> */}
                <TableCell className={classes.tableCell} align="left">
                  <Button
                    onClick={e => {
                      e.stopPropagation();
                      history.push(`/accommodations/${accommodation.id}/book`);
                    }}
                    variant="outlined"
                    color="primary"
                    classes={{ root: classes.buttonRoot }}
                  >
                    {t('Book')}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>

      {data && (
        <Pagination
          page={page + 1}
          count={data.numberOfAccommodationsPages}
          onChange={onPageChangeHandler}
          amount={data.accommodations.length}
          total={data.accommodationsActivitiesOverview.accommodations.total}
        />
      )}
    </TableContainer>
  );
}

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(AccommodationsList);
